// extracted by mini-css-extract-plugin
export default {"icon":"BackButton__icon--2lxR-"};